import Button from '@salesforce/design-system-react/components/button';
import Icon from '@salesforce/design-system-react/components/icon';
import ProgressBar from '@salesforce/design-system-react/components/progress-bar';
import AccordionPanel from '@salesforce/design-system-react/components/accordion/panel';
import Accordion from '@salesforce/design-system-react/components/accordion';
import classNames from 'classnames';
import {
  FactoryEmaillabApiV1Campaign,
  FactoryEmaillabApiV1Folder,
  useCampaignServiceSyncCampaignMutation
} from '../../app/apiGenerated';
import { formatPeriod } from '../../components/JSONSchemaForm/theme/fields/PeriodSelectorField';
import { GoogleColorToHex } from '../../components/Badges/Badges';
import { useState } from 'react';

const FoldersList = ({
  separators,
  onClickFolder,
  onClickCampaign,
  onClickEdit,
  onClickDelete
}: {
  separators?: FactoryEmaillabApiV1Folder[];
  onClickFolder?: (folders: FactoryEmaillabApiV1Folder[]) => void;
  onClickCampaign?: (folder: FactoryEmaillabApiV1Folder) => void;
  onClickEdit?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClickDelete?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
}) => {
  const [toggledSeparators, setToggledSeparators] = useState<
    Record<string, boolean>
  >({});
  return (
    <div
      className="slds-p-around_medium slds-m-left_none "
      style={{ flexGrow: '1', overflowY: 'auto' }}
    >
      <Accordion>
        {separators?.map((separator) => {
          return (
            <AccordionPanel
              expanded={
                toggledSeparators[separator.name || ''] !== undefined
                  ? toggledSeparators[separator.name || '']
                  : true
              }
              id={separator.name || ''}
              panelContentActions={<></>}
              key={separator.name}
              onTogglePanel={() =>
                setToggledSeparators({
                  ...toggledSeparators,
                  [separator.name || '']:
                    toggledSeparators[separator.name || ''] === undefined
                      ? false
                      : !toggledSeparators[separator.name || '']
                })
              }
              summary={
                <span className="slds-text-title slds-grid slds-grid_vertical-align-center">
                  {/* <Icon category="standard" name="assignment" size="x-small" /> */}
                  <span className="slds-text-heading_medium">
                    <strong className=" slds-m-left_x-small">
                      {separator.display_name}
                    </strong>
                  </span>
                  <span className="slds-m-left_x-small">
                    <i>Folders: {separator.folders?.length || 0}</i>
                  </span>
                  <span className="slds-m-left_x-small">
                    <i>Campaigns: {separator.campaigns?.length || 0}</i>
                  </span>
                </span>
              }
            >
              <div className="slds-grid slds-gutters slds-wrap slds-p-around_small">
                {[...(separator.folders || [])]
                  ?.sort((a, b) =>
                    a.display_name?.localeCompare(b.display_name)
                  )
                  ?.map((folder) => {
                    return (
                      <FolderObjectDetails
                        key={folder.name}
                        item={folder}
                        onClickEdit={onClickEdit}
                        onClick={(folder) => {
                          onClickFolder?.([separator, folder]);
                        }}
                        onClickDelete={onClickDelete}
                        width="20rem"
                      />
                    );
                  })}
                {[...(separator.campaigns || [])]
                  ?.sort((a, b) =>
                    a.display_name?.localeCompare(b.display_name)
                  )
                  ?.map((campaign) => {
                    return (
                      <CampaignObjectDetails
                        key={campaign.name}
                        item={campaign}
                        onClickEdit={onClickEdit}
                        onClick={onClickCampaign}
                        onClickDelete={onClickDelete}
                        width="20rem"
                      />
                    );
                  })}
              </div>
            </AccordionPanel>
          );
        })}
      </Accordion>
    </div>
  );
};

export const FolderObjectDetails = ({
  item,
  onClickEdit,
  onClose,
  onClickDelete,
  onClick,
  onMouseEnter,
  onMouseLeave,
  noBorder = false,
  width = '40rem',
  actions
}: {
  item: FactoryEmaillabApiV1Folder;
  onClickEdit?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClick?: (folder: FactoryEmaillabApiV1Folder) => void;
  onClose?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClickDelete?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  noBorder?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  width?: string;
  actions?: React.ReactNode;
}) => {
  return (
    <section
      aria-labelledby="panel-heading-id"
      className={classNames(
        'folder-listing slds-popover_panel slds-p-around_none overflow-hidden slds-grid slds-grid_vertical slds-m-right_small slds-m-bottom_small',
        {
          'slds-box': !noBorder
        }
      )}
      style={{
        background: 'rgba(0,0,0,.07)',
        width: width,
        height: '9rem',
        cursor: 'pointer'
      }}
      role="dialog"
      onMouseUp={() => onClick?.(item)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="slds-p-horizontal_medium slds-p-vertical_xx-small slds-grid height-100">
        <div className="flex-grow-1">
          <dt className=" height-100">
            <div className="slds-media slds-grid slds-grid_vertical-align-center slds-media_center  slds-grid_align-center  height-100">
              <div
                className="slds-media__figure slds-m-right_none"
                // style={{ alignSelf: 'flex-start' }}
              >
                {/* <Icon category="standard" name="folder" size="small" /> */}
                <Icon
                  category="doctype"
                  name="folder"
                  style={{ width: '7rem', height: '5rem' }}
                />
              </div>
              <div className="slds-media__body  slds-text-align_center">
                <p className="slds-text-heading_small slds-hyphenate">
                  <strong>{item?.display_name}</strong>
                </p>
                <p className="slds-text-body_small">
                  <i>Folders : {item?.folders?.length || 0}</i>{' '}
                  <i>Campaigns : {item?.campaigns?.length || 0}</i>
                </p>
              </div>
            </div>
          </dt>
        </div>
        <div
          style={{
            flex: 'none'
          }}
          className="slds-p-left_x-small"
        >
          <>
            {onClickDelete !== undefined && (
              <Button
                iconCategory="utility"
                iconName="delete"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickDelete?.(item)}
              />
            )}
            {onClickEdit !== undefined && (
              <Button
                iconCategory="utility"
                iconName="edit"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickEdit?.(item)}
              />
            )}
            {onClose !== undefined && (
              <Button
                iconCategory="utility"
                iconName="close"
                iconVariant="bare"
                variant="icon"
                iconSize="large"
                onClick={() => {
                  onClose?.(item);
                }}
              />
            )}
            {actions !== undefined && actions}
          </>
        </div>
      </div>
    </section>
  );
};

export const CampaignObjectDetails = ({
  item,
  onClickEdit,
  onClose,
  onClickDelete,
  onClick,
  onMouseEnter,
  onMouseLeave,
  noBorder = false,
  width = '40rem',
  actions
}: {
  item: FactoryEmaillabApiV1Campaign;
  onClickEdit?: (campaign: FactoryEmaillabApiV1Campaign | undefined) => void;
  onClick?: (campaign: FactoryEmaillabApiV1Campaign) => void;
  onClose?: (campaign: FactoryEmaillabApiV1Campaign | undefined) => void;
  onClickDelete?: (campaign: FactoryEmaillabApiV1Campaign | undefined) => void;
  noBorder?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  width?: string;
  actions?: React.ReactNode;
}) => {
  return (
    <section
      aria-labelledby="panel-heading-id"
      className={classNames(
        'campaign-listing slds-popover_panel slds-p-around_none overflow-hidden slds-grid slds-grid_vertical slds-m-right_small slds-m-bottom_small slds-is-relative',
        {
          'slds-box': !noBorder
        }
      )}
      style={{
        background: '#fff',
        width: width,
        height: '9rem'
        // cursor: 'pointer'
      }}
      role="dialog"
      // onMouseUp={() => onClick?.(item)}
      // onMouseEnter={onMouseEnter}
      // onMouseLeave={onMouseLeave}
    >
      <div className="sync-button-container slds-grid slds-grid_align-center slds-grid_vertical-align-center">
        <Button
          iconCategory="utility"
          iconName="upload"
          label="Upload to Content Builder"
          iconPosition="left"
          variant="brand"
          onClick={() => {
            onClick?.(item);
            // console.log('totototo');
          }}
        />
      </div>
      <div className="slds-p-horizontal_medium slds-p-vertical_medium slds-grid">
        <div className="flex-grow-1">
          <dt className="">
            <div className="slds-media slds-media_center">
              <div
                className="slds-media__figure"
                style={{ alignSelf: 'flex-start' }}
              >
                <Icon category="standard" name="campaign" size="small" />
              </div>
              <div className="slds-media__body">
                <p className="slds-text-heading_small slds-hyphenate">
                  <strong>{item?.display_name}</strong>
                </p>
              </div>
            </div>
          </dt>
        </div>
        <div
          style={{
            flex: 'none'
          }}
          className="slds-p-left_x-small"
        >
          <>
            {onClickDelete !== undefined && (
              <Button
                iconCategory="utility"
                iconName="delete"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickDelete?.(item)}
              />
            )}
            {onClickEdit !== undefined && (
              <Button
                iconCategory="utility"
                iconName="edit"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickEdit?.(item)}
              />
            )}
            {onClose !== undefined && (
              <Button
                iconCategory="utility"
                iconName="close"
                iconVariant="bare"
                variant="icon"
                iconSize="large"
                onClick={() => {
                  onClose?.(item);
                }}
              />
            )}
            {actions !== undefined && actions}
          </>
        </div>
      </div>
    </section>
  );
};

export const SeparatorObjectDetails = ({
  item,
  onClickEdit,
  onClose,
  onClickDelete,
  onClick,
  onMouseEnter,
  onMouseLeave,
  noBorder = false,
  width = '40rem',
  actions
}: {
  item: FactoryEmaillabApiV1Folder | undefined;
  onClickEdit?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClick?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClose?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  onClickDelete?: (folder: FactoryEmaillabApiV1Folder | undefined) => void;
  noBorder?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  width?: string;
  actions?: React.ReactNode;
}) => {
  return <></>;
};
export default FoldersList;
